import React from "react";
import { ScanBarcode, PackageCheck, CheckCircle2 } from "lucide-react";
import { StatCard, StatCardSkeleton } from "src/components/ui/statCard";

export interface RelabelCaseStatsCardsProps {
  isLoading: boolean;
  pendingCount: number;
  inRelabellingCount: number;
  completeCount: number;
}

export const RelabelCaseStatsCards: React.FC<RelabelCaseStatsCardsProps> = ({
  isLoading,
  pendingCount,
  inRelabellingCount,
  completeCount
}) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
    {isLoading ? (
      <>
        <StatCardSkeleton />
        <StatCardSkeleton />
        <StatCardSkeleton />
      </>
    ) : (
      <>
        <StatCard
          icon={ScanBarcode}
          title="Pending Scan-In"
          value={pendingCount}
          accentClass="bg-amber-500"
          iconBgClass="bg-amber-50"
          iconColorClass="text-amber-600"
        />
        <StatCard
          icon={PackageCheck}
          title="In Relabelling"
          value={inRelabellingCount}
          accentClass="bg-blue-500"
          iconBgClass="bg-blue-50"
          iconColorClass="text-blue-600"
        />
        <StatCard
          icon={CheckCircle2}
          title="Complete"
          value={completeCount}
          accentClass="bg-emerald-500"
          iconBgClass="bg-emerald-50"
          iconColorClass="text-emerald-600"
        />
      </>
    )}
  </div>
);
